import { Icon, Card } from '@nike/eds'
import { TrackTraceException } from '../../generated/graphql'

function TrackAndTraceExceptionAlert({ code, description }: TrackTraceException) {
  return (
    <div className="error-message">
      <Icon name="AlertCircle" size="s" style={{ marginRight: '6px' }} />
      <div>
        {' '}
        {code}: {description}
      </div>
    </div>
  )
}
export function TrackAndTraceExceptions({ ttExceptions }: { ttExceptions: TrackTraceException[] }) {
  return (
    <Card className="tt-exceptions error-container">
      {ttExceptions.map((e) => (
        <TrackAndTraceExceptionAlert key={e.code} {...e} />
      ))}
    </Card>
  )
}
